(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function(){
    'use strict';
    var burger = document.querySelector('[data-tzh-burger]');
    var drawer = document.querySelector('[data-tzh-drawer]');
    var closes = document.querySelectorAll('[data-tzh-drawer-close]');
    function openDrawer(){ if(!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); if(burger) burger.setAttribute('aria-expanded','true'); document.body.style.overflow='hidden'; }
    function closeDrawer(){ if(!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); if(burger) burger.setAttribute('aria-expanded','false'); document.body.style.overflow=''; }
    if(burger) burger.addEventListener('click', openDrawer);
    closes.forEach(function(el){ el.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeDrawer(); });

    // Cart badge — fail-safe live update via Shopify Ajax API
    function refreshCart(){
      try {
        fetch('/cart.js', { credentials:'same-origin' })
          .then(function(r){ return r.ok ? r.json() : null; })
          .then(function(data){
            if(!data) return;
            var count = (data.item_count != null) ? data.item_count : 0;
            document.querySelectorAll('[data-tzh-cart-count]').forEach(function(el){
              el.textContent = count;
              var badge = el.closest('.tzh-header__cart-badge');
              if(badge){
                if(count > 0) badge.classList.remove('is-empty');
                else badge.classList.add('is-empty');
              }
            });
          })
          .catch(function(){ /* silent */ });
      } catch(e) {}
    }
    refreshCart();
    document.addEventListener('cart:refresh', refreshCart);
    // Listen to native Shopify cart events
    ['cart:updated','cart:item-added','cart:changed'].forEach(function(ev){ document.addEventListener(ev, refreshCart); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tzh-bart-check"] && !Shopify.designMode) return;
  try {
    

  document.addEventListener('click', function(e) {
    var q = e.target.closest('.faq__q');
    if (q) q.parentElement.classList.toggle('is-open');
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tzh-berater"] && !Shopify.designMode) return;
  try {
    

  // Advisor-Modal-Trigger — wird funktional, sobald tzh-config.js + advisor.js geladen sind
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-action="open-advisor"]');
    if (!btn) return;
    e.preventDefault();
    if (window.Advisor && typeof window.Advisor.open === 'function') {
      window.Advisor.open();
    } else {
      // Fallback: scroll to questions section if Advisor JS not loaded
      var target = document.getElementById('advisor-start');
      if (target) target.scrollIntoView({behavior:'smooth'});
    }
  });


  } catch(e) { console.error(e); }
})();
})();
